export var Modes;
(function (Modes) {
    Modes["popup"] = "popup";
    Modes["page"] = "page";
    Modes["story"] = "story";
})(Modes || (Modes = {}));
export var ShopifyTemplate;
(function (ShopifyTemplate) {
    ShopifyTemplate["Product"] = "shopify-product";
    ShopifyTemplate["Page"] = "shopify-page";
    ShopifyTemplate["Collection"] = "shopify-collection";
    ShopifyTemplate["Article"] = "shopify-article";
    ShopifyTemplate["Blog"] = "shopify-blog";
})(ShopifyTemplate || (ShopifyTemplate = {}));
export var Target;
(function (Target) {
    Target["builder"] = "@builder";
})(Target || (Target = {}));
